
import axios from 'axios';
import { getLeadMailPayload } from '../../../selectors/sizotsaFuneralCover/quote';

export const sizotsaLeadsMailService = (store, next, action) => {
    const state=store.getState();
    (async () => {

        const dataEmailObj = getLeadMailPayload(state)
        const requestBody = {
            firstName:' ',
            lastName:' ',
            contactNumber:'',
            subject:`Web: Sizotsa funeral`,
            userDataFields: dataEmailObj,
            templateType:"ALLSURE_QUOTE_CUSTOMER",
            monthlyPremium:  null,
            yearlyPremium: null,
            referenceNumber: null,
            email: 'SIZOSTA_FUNERAL_BUSSINESS_MAIL',
        }
        const quoteData = await sendEmailNotification(requestBody);
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            url: 'om-api/submit-notification/submitNotificationEmail',
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        return null;
    }
};
export const sendEmailNotificationWithAttachments = async (requestBody) => {
    try {
        const response = await axios({
            url: 'om-api/submit-notification/submitNotificationEmail/withAttachments',
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        return null;
    }
};










